// import React, { useState, useContext, useEffect } from "react";
// import { Box, IconButton, Popover, Typography, useTheme, Tooltip } from "@mui/material";
// import { ColorModeContext, tokens } from "../../theme";
// import LightModeOutLinedIcon from "@mui/icons-material/LightModeOutlined";
// import DarkModeOutLinedIcon from "@mui/icons-material/DarkModeOutlined";
// import SettingsOutLinedIcon from "@mui/icons-material/SettingsOutlined";
// import PersonOutLinedIcon from "@mui/icons-material/PersonOutlined";
// import NotificationsOutLinedIcon from "@mui/icons-material/NotificationsOutlined";
// import LogoutOutlinedIcon from '@mui/icons-material/LogoutOutlined';
// import HomeOutLinedIcon from "@mui/icons-material/HomeOutlined";
// import { useNavigate } from 'react-router-dom';
// import SearchIcon from "@mui/icons-material/Search";
// import InputBase from "@mui/material/InputBase";
// import axios from 'axios';


// const Topbar = ({ onSearch, name, selectedCompany, selectedYear, selectedDept, handleLogout }) => {
//   const [profileAnchor, setProfileAnchor] = useState(null);
//   const theme = useTheme();
//   const colorMode = useContext(ColorModeContext);

//   const [compMasterEntries, setCompMasterEntries] = useState([]);
//   const [deptMasterEntries, setDeptMasterEntries] = useState([]);
//   const [yearMasterEntries, setYearMasterEntries] = useState([]);
//   const navigate = useNavigate();

//   useEffect(() => {
//     fetchDeptMaster();
//     fetchCompMaster();
//     fetchYearMaster();
//   }, []);

//   //const findCompanyName = (code) => compMasterEntries.find((group) => group.CompCode === code)?.CompName || '';

//   const findCompanyName = (code) => {
//     const companyName = compMasterEntries.find((group) => group.CompCode === code)?.CompName || '';
//     const companyNameParts = companyName.split(',');
//     return companyNameParts[0].trim();
//   };
//   const findDeptName = (code) => deptMasterEntries.find((group) => group.DeptCode === code)?.DeptName || '';
//   const findYearName = (code) => yearMasterEntries.find((group) => group.YearCode === code)?.FinancialYear || '';


//   const fetchCompMaster = async () => {
//     try {
//       const response = await axios.get('https://www.wingap.net.in/api/company');
//       setCompMasterEntries(response.data);
//       //console.log(response);
//     } catch (error) {
//       console.log('error:', error);
//     }
//   };

//   const fetchDeptMaster = async () => {
//     try {
//       const response = await axios.get('https://www.wingap.net.in/api/items');
//       setDeptMasterEntries(response.data);
//       //console.log(response);
//     } catch (error) {
//       console.log('error:', error);
//     }
//   };

//   const fetchYearMaster = async () => {
//     try {
//       const response = await axios.get('https://www.wingap.net.in/api/year_master');
//       setYearMasterEntries(response.data);
//       //console.log(response);
//     } catch (error) {
//       console.log('error:', error);
//     }
//   };

//   const handleProfileClick = (event) => {
//     setProfileAnchor(event.currentTarget);
//   };

//   const handleProfileClose = () => {
//     setProfileAnchor(null);
//   };

//   const handleSearchChange = (event) => {
//     const searchQuery = event.target.value;
//     onSearch(searchQuery);
//   };

//   const handleDashboard = () => {
//     navigate('/Dashboard');
//   };

//   return (
//     <Box display="flex" justifyContent="space-between" p={0.8}>
//       {/* Search bar */}
//       <Box display="flex" backgroundColor="primary.4000" borderRadius="3px">
//         <InputBase
//           sx={{ ml: 2, flex: 1 }}
//           placeholder="Search"
//           onChange={handleSearchChange}
//         />
//         <IconButton type="button" sx={{ p: 1 }}>
//           <SearchIcon />
//         </IconButton>
//       </Box>
//       <Box textAlign="center" mt={1}>
//         <Typography variant="h3" style={{ textAlign: 'center', color: '#301E67', fontWeight: 'bold', fontFamily: 'Arial, sans-serif', textShadow: '2px 2px 4px rgba(0, 0, 0, 0.3)' }}>
//           {findCompanyName(selectedCompany)} - &nbsp;
//           <Typography component="span" variant="h3" style={{ color: 'green', fontWeight: 'bold', fontFamily: 'Arial, sans-serif', textShadow: '2px 2px 4px rgba(0, 0, 0, 0.3)' }}>
//             F.Y&nbsp;-&nbsp;{findYearName(selectedYear)}
//           </Typography>
//         </Typography>

//         <Typography variant="h7" style={{ color: 'darkgreen', fontWeight: 'bold', fontFamily: 'Arial, sans-serif' }}>
//         Company Code : {selectedCompany} &nbsp;&nbsp;&nbsp; Year Code : {selectedYear} &nbsp;&nbsp;&nbsp;  Dept Code : {selectedDept} &nbsp;&nbsp;&nbsp;
//       </Typography>
//       </Box>
//       {/* Icons */}
//       <Box display="flex">
//         <Tooltip title='Dashboard'>
//           <IconButton onClick={handleDashboard} sx={{ marginRight: '5px' }}>
//             <HomeOutLinedIcon sx={{ fontSize: 23 }} />
//           </IconButton>
//         </Tooltip>
//         <IconButton onClick={colorMode.toggleColorMode}>
//           {theme.palette.mode === 'light' ? (
//             <LightModeOutLinedIcon sx={{ fontSize: 23 }} />
//           ) : (
//             <DarkModeOutLinedIcon sx={{ fontSize: 23 }} />
//           )}
//         </IconButton>
//         <IconButton onClick={handleProfileClick}>
//           <PersonOutLinedIcon sx={{ fontSize: 23 }} />
//         </IconButton>
//         <Popover
//           open={Boolean(profileAnchor)}
//           anchorEl={profileAnchor}
//           onClose={handleProfileClose}
//           anchorOrigin={{
//             vertical: "bottom",
//             horizontal: "right",
//           }}
//           transformOrigin={{
//             vertical: "top",
//             horizontal: "right",
//           }}
//         >
//           <Box p={2}>
//             {/* Display user information and logout button */}
//             <Typography>Username: {name}</Typography>
//             <Typography variant="body2" color="textSecondary">
//               user@example.com
//             </Typography>
//             <button onClick={() => handleLogout()} style={{ height: '25px', backgroundColor: 'greenyellow' }}>Logout</button>
//           </Box>
//         </Popover>

//         <Tooltip title='Logout'>
//           <IconButton onClick={handleLogout} sx={{ color: 'red' }}>
//             <LogoutOutlinedIcon sx={{ fontSize: 23 }} />
//           </IconButton>
//         </Tooltip>
//       </Box>
//     </Box>
//   );
// };

// export default Topbar;
import React, { useState, useContext, useEffect, useRef } from "react";
import { Box, IconButton, Popover, Typography, useTheme, Tooltip } from "@mui/material";
import { ColorModeContext, tokens } from "../../theme";
import LightModeOutLinedIcon from "@mui/icons-material/LightModeOutlined";
import DarkModeOutLinedIcon from "@mui/icons-material/DarkModeOutlined";
import SettingsOutLinedIcon from "@mui/icons-material/SettingsOutlined";
import PersonOutLinedIcon from "@mui/icons-material/PersonOutlined";
import HomeOutlinedIcon from '@mui/icons-material/HomeOutlined';
import PersonAddOutlinedIcon from '@mui/icons-material/PersonAddOutlined';
import LogoutOutlinedIcon from '@mui/icons-material/LogoutOutlined';
import SearchIcon from "@mui/icons-material/Search";
import InputBase from "@mui/material/InputBase";
import { useNavigate } from 'react-router-dom';
import ClearIcon from '@mui/icons-material/Clear';
import axios from 'axios';


const Topbar = ({ onSearch, name, selectedCompany, selectedYear, selectedDept, admin, handleLogout }) => {
  const [profileAnchor, setProfileAnchor] = useState(null);
  const theme = useTheme();
  const colorMode = useContext(ColorModeContext);
  const inputRef = useRef(null);

  const [compMasterEntries, setCompMasterEntries] = useState([]);
  const [deptMasterEntries, setDeptMasterEntries] = useState([]);
  const [yearMasterEntries, setYearMasterEntries] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
    fetchDeptMaster();
    fetchCompMaster();
    fetchYearMaster();
  }, []);

  const findCompanyName = (code) => compMasterEntries.find((group) => group.CompCode === code)?.CompName || '';
  const findDeptName = (code) => deptMasterEntries.find((group) => group.DeptCode === code)?.DeptName || '';
  const findYearName = (code) => yearMasterEntries.find((group) => group.YearCode === code)?.FinancialYear || '';


  const fetchCompMaster = async () => {
    try {
      const response = await axios.get('https://www.wingap.net.in/api/company');
      setCompMasterEntries(response.data);
      //console.log(response)
    } catch (error) {
      console.log('error:', error);
    }
  };

  const fetchDeptMaster = async () => {
    try {
      const response = await axios.get('https://www.wingap.net.in/api/items');
      setDeptMasterEntries(response.data);
      //console.log(response);
    } catch (error) {
      console.log('error:', error);
    }
  };

  const fetchYearMaster = async () => {
    try {
      const response = await axios.get('https://www.wingap.net.in/api/year_master');
      setYearMasterEntries(response.data);
      //console.log(response);
    } catch (error) {
      console.log('error:', error);
    }
  };

  const handleProfileClick = (event) => {
    setProfileAnchor(event.currentTarget);
  };

  const handleProfileClose = () => {
    setProfileAnchor(null);
  };

  const handleUserButton = () => {
    navigate('/createuser');
  };

  const handleDashboard = () => {
    navigate('/Dashboard');
  };

  const handleSearchChange = (event) => {
    const searchQuery = event.target.value;
    onSearch(searchQuery);
  };

  const handleClear = () => {
    if (inputRef.current) {
      inputRef.current.value = '';
      onSearch('');
    }
  };



  return (
    <>
      <Box
        sx={{
          position: 'fixed',
          top: 0,
          width: '94%',
          backgroundColor: 'rgba(255, 255, 255, 0.9)',
          color: '#666',
          textAlign: 'center',
          fontSize: '0.8rem',
          padding: '5px 0',
          borderTop: '1px solid #ddd',
          zIndex: 10
        }}
      >
        <Box sx={{ display: 'flex', justifyContent: 'start', gap: '10px', fontSize: '0.75rem', color: '#666', marginLeft: '16px' }}>
          <Box sx={{ display: 'flex', alignItems: 'center', fontWeight: 'medium', fontSize: '0.75rem' }}>
            Developed by :- WELL SOFTWARE, KOLHAPUR
          </Box>
          <Box sx={{ display: 'flex', alignItems: 'center' }}>
            <span role="img" aria-label="phone">📞</span> +919422043590
          </Box>
          <Box sx={{ display: 'flex', alignItems: 'center' }}>
            <span role="img" aria-label="email">✉️</span> wellsoftkop@yahoo.co.in
          </Box>
        </Box>
      </Box>
      {/* <Box display="flex" justifyContent="space-between" p={1} pb={0} pt={0} mt={.2}>
        <Box display="flex" backgroundColor="primary.4000" borderRadius="3px">
          <InputBase
            sx={{ ml: 2, flex: 1 }}
            placeholder="Search"
            inputRef={inputRef} // Attach ref to the InputBase component
            onChange={handleSearchChange}
          />
          <IconButton type="button" sx={{ p: 1 }}>
            <SearchIcon />
          </IconButton>
          <IconButton type="button" sx={{ p: 1 }} onClick={handleClear}>
            <ClearIcon />
          </IconButton>
        </Box>
        <Box textAlign="center" mt={3}>
          <Typography variant="h4" style={{ color: '#21519e', fontWeight: 'bold', fontFamily: 'Arial, sans-serif', textShadow: '2px 2px 4px rgba(0, 0, 0, 0.3)' }}>
            {findCompanyName(selectedCompany)} - F.Y&nbsp;{findYearName(selectedYear)} - {findDeptName(selectedDept)}
          </Typography>
          <Typography variant="h6" style={{ color: 'green', fontWeight: 'bold', fontFamily: 'Arial, sans-serif', textShadow: '2px 2px 4px rgba(0, 0, 0, 0.3)' }}>
            Company Code : {selectedCompany} &nbsp;&nbsp;&nbsp; Year Code : {selectedYear} &nbsp;&nbsp;&nbsp;  Dept Code : {selectedDept}
          </Typography>
        </Box>
      
        <Box display="flex">
          <Tooltip title='Home'>
            <IconButton onClick={handleDashboard} sx={{ p: 1 }}>
              <HomeOutlinedIcon sx={{ fontSize: 23 }} />
            </IconButton>
          </Tooltip>
          <Tooltip title='View User'>
            <IconButton onClick={handleProfileClick} sx={{ p: 1 }}>
              <PersonOutLinedIcon sx={{ fontSize: 23 }} />
            </IconButton>
          </Tooltip>
          <Popover
            open={Boolean(profileAnchor)}
            anchorEl={profileAnchor}
            onClose={handleProfileClose}
            anchorOrigin={{
              vertical: "bottom",
              horizontal: "right",
            }}
            transformOrigin={{
              vertical: "top",
              horizontal: "right",
            }}
          >
            <Box p={2}>
              <Typography>Username: {name}</Typography>
              <Typography variant="body2" color="textSecondary">
                user@example.com
              </Typography>
              <button onClick={handleProfileClose}>Logout</button>
            </Box>
          </Popover>
          {(admin === true) && <Tooltip title='Create User'>
            <IconButton onClick={handleUserButton} sx={{ p: 1 }}>
              <PersonAddOutlinedIcon sx={{ fontSize: 23 }} />
            </IconButton>
          </Tooltip>}
          <Tooltip title={theme.palette.mode === 'light' ? 'Switch to Dark Mode' : 'Switch to Light Mode'}>
            <IconButton onClick={colorMode.toggleColorMode} sx={{ p: 1 }}>
              {theme.palette.mode === 'light' ? (
                <DarkModeOutLinedIcon sx={{ fontSize: 23 }} />
              ) : (
                <LightModeOutLinedIcon sx={{ fontSize: 23 }} />
              )}
            </IconButton>
          </Tooltip>
          <Tooltip title='Logout'>
            <IconButton onClick={handleLogout} sx={{ color: 'red', p: 1 }}>
              <LogoutOutlinedIcon sx={{ fontSize: 23 }} />
            </IconButton>
          </Tooltip>
        </Box>
      </Box> */}
      <Box display="flex" justifyContent="space-between" p={1} pb={0} pt={0} mt={0.3}>
        <Box display="flex" backgroundColor="primary.4000" borderRadius="3px">
          <InputBase
            sx={{ ml: 2, flex: 1 }}
            placeholder="Search"
            inputRef={inputRef} // Attach ref to the InputBase component
            onChange={handleSearchChange}
          />
          <IconButton type="button" sx={{ p: 1 }}>
            <SearchIcon />
          </IconButton>
          <IconButton type="button" sx={{ p: 1 }} onClick={handleClear}>
            <ClearIcon />
          </IconButton>
        </Box>

        {/* Center section with company details */}
        {/* <Box textAlign="center" mt={3}>
          <Typography
            variant="h4"
            style={{
              color: '#21519e',
              fontWeight: 'bold',
              fontFamily: 'Arial, sans-serif',
              textShadow: '2px 2px 4px rgba(0, 0, 0, 0.3)',
            }}
          >
            {findCompanyName(selectedCompany)}
          </Typography>
          <Typography
            variant="h7"
            style={{
              color: 'green',
              fontWeight: 'bold',
              fontFamily: 'Arial, sans-serif',
              textShadow: '2px 2px 4px rgba(0, 0, 0, 0.3)',
            }}
          >
            Dept : {findDeptName(selectedDept)} &nbsp;&nbsp;&nbsp;  Year : F.Y&nbsp;{findYearName(selectedYear)} 
          </Typography>
        </Box> */}
        <Box textAlign="center" mt={3}>
          <Typography
            variant="h3"
            style={{
              color: '#003366', // Deep blue for company name
              fontWeight: 'bold',
              fontFamily: 'Arial, sans-serif',
              textShadow: '2px 2px 4px rgba(0, 0, 0, 0.2)', // Subtle shadow for depth
            }}
          >
            {findCompanyName(selectedCompany)}
          </Typography>
          <Typography
            variant="h7"
            style={{
              color: 'rgb(36, 143, 36)',
              fontWeight: 'bold',
              fontFamily: 'Arial, sans-serif',
              //textShadow: '1px 1px 3px rgba(0, 0, 0, 0.2)',
            }}
          >
            Year: <span>F.Y {findYearName(selectedYear)}</span> {/* Deep red for the year */}
          </Typography>
        {/* Company Code : {selectedCompany} &nbsp;&nbsp;&nbsp; Year Code : {selectedYear} &nbsp;&nbsp;&nbsp; Dept Code : {selectedDept} */}
        </Box>


        {/* Right section with user details */}
        <Box display="flex" alignItems="center">
          <Box
            sx={{
              backgroundColor: '#f0f4ff', 
              padding: '4px 6px',       
              borderRadius: '10px',      
              boxShadow: '0px 4px 8px rgba(0, 0, 0, 0.1)', // Subtle shadow
              display: 'flex',
              alignItems: 'center',
              color: '#21519e',          // Text color to match your theme
              fontWeight: 'bold',
              fontFamily: 'Arial, sans-serif',
              fontSize: '0.72rem',
            }}
          >
            Username: {name}
          </Box>
          <Tooltip title="Home">
            <IconButton onClick={handleDashboard} sx={{ p: 1 }}>
              <HomeOutlinedIcon sx={{ fontSize: 23 }} />
            </IconButton>
          </Tooltip>
          <Tooltip title="View User">
            <IconButton onClick={handleProfileClick} sx={{ p: 1 }}>
              <PersonOutLinedIcon sx={{ fontSize: 23 }} />
            </IconButton>
          </Tooltip>
          <Popover
            open={Boolean(profileAnchor)}
            anchorEl={profileAnchor}
            onClose={handleProfileClose}
            anchorOrigin={{
              vertical: 'bottom',
              horizontal: 'right',
            }}
            transformOrigin={{
              vertical: 'top',
              horizontal: 'right',
            }}
          >
            <Box p={1.4}>
              <Typography>Username: {name}</Typography>
              <button onClick={handleProfileClose} style={{ backgroundColor: 'lightgreen', border: 'none', padding: '2px', borderRadius: '4px' }}>
                Logout
              </button>
            </Box>
          </Popover>
          {admin === true && (
            <Tooltip title="Create User">
              <IconButton onClick={handleUserButton} sx={{ p: 1 }}>
                <PersonAddOutlinedIcon sx={{ fontSize: 23 }} />
              </IconButton>
            </Tooltip>
          )}
          <Tooltip title={theme.palette.mode === 'light' ? 'Switch to Dark Mode' : 'Switch to Light Mode'}>
            <IconButton onClick={colorMode.toggleColorMode} sx={{ p: 1 }}>
              {theme.palette.mode === 'light' ? (
                <DarkModeOutLinedIcon sx={{ fontSize: 23 }} />
              ) : (
                <LightModeOutLinedIcon sx={{ fontSize: 23 }} />
              )}
            </IconButton>
          </Tooltip>
          <Tooltip title="Logout">
            <IconButton onClick={handleLogout} sx={{ color: 'red', p: 1 }}>
              <LogoutOutlinedIcon sx={{ fontSize: 23 }} />
            </IconButton>
          </Tooltip>
        </Box>
      </Box>

    </>
  );
};

export default Topbar;

